import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol viewBox=\"0 0 1000 1000\" id=\"icon-search\">\n<metadata> Svg Vector Icons : http://www.sfont.cn </metadata>\n<g><path d=\"M962.2,816.5l-181-181c33.7-59.8,53.3-128.7,53.3-202.1c0-227.3-185-412.2-412.3-412.2S10,206.1,10,433.4c0,227.3,184.9,412.2,412.1,412.2c85,0,164.1-26,229.9-70.2l175.6,175.7c18.6,18.5,42.9,27.7,67.3,27.7s48.6-9.3,67.3-27.7C999.3,913.9,999.3,853.7,962.2,816.5z M136.8,433.4c0-157.4,128-285.4,285.3-285.4c157.5,0,285.5,128.1,285.5,285.4c0,157.3-128,285.4-285.5,285.4C264.9,718.8,136.8,590.8,136.8,433.4z\" /></g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/search.svg
// module id = Bx0U
// module chunks = 76